import type {AgentInfo} from '../types/session'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import {useQuery} from '@github-ui/react-query'

export function useTopLevelAgents(nwo?: string, enabled = true) {
  const query = useQuery<AgentInfo[]>({
    enabled: Boolean(nwo) && enabled,
    queryKey: ['top-level-agents', nwo],
    queryFn: async () => {
      try {
        if (!nwo) {
          return []
        }

        const response = await verifiedFetchJSON(`/copilot/agent-sessions/${nwo}/agents`)
        if (!response.ok) {
          return []
        }

        const data = await response.json()
        return (data.agents as AgentInfo[]) || []
      } catch {
        return []
      }
    },
  })

  return query
}
